// Italian provinces (sigla → name → region), 110 entries — current as of the
// Sardinian provincial reform operative since 2025 (Sud Sardegna dissolved,
// Sassari a metropolitan city, Sulcis Iglesiente/Medio Campidano/Ogliastra/
// Gallura Nord-Est Sardegna reinstated).
//
// The Italian team announced their own province code/list (change request
// 2026-08-25, §3.3); if it differs, swap the entries here — everything else
// (dropdowns, region derivation, sync) keys off this file.
//
// `region` values must match STATES_BY_COUNTRY.Italy in Step3AddressData.tsx —
// the region is auto-derived from the selected province and stored in
// addressData.state, which downstream (DB, PVS sync) already consumes.

export interface ItalianProvince {
  /** Two-letter province code (sigla automobilistica), the stored value. */
  sigla: string
  name: string
  region: string
}

export const ITALIAN_PROVINCES: ItalianProvince[] = [
  // Abruzzo
  { sigla: 'AQ', name: "L'Aquila", region: 'Abruzzo' },
  { sigla: 'CH', name: 'Chieti', region: 'Abruzzo' },
  { sigla: 'PE', name: 'Pescara', region: 'Abruzzo' },
  { sigla: 'TE', name: 'Teramo', region: 'Abruzzo' },
  // Basilicata
  { sigla: 'MT', name: 'Matera', region: 'Basilicata' },
  { sigla: 'PZ', name: 'Potenza', region: 'Basilicata' },
  // Calabria
  { sigla: 'CS', name: 'Cosenza', region: 'Calabria' },
  { sigla: 'CZ', name: 'Catanzaro', region: 'Calabria' },
  { sigla: 'KR', name: 'Crotone', region: 'Calabria' },
  { sigla: 'RC', name: 'Reggio Calabria', region: 'Calabria' },
  { sigla: 'VV', name: 'Vibo Valentia', region: 'Calabria' },
  // Campania
  { sigla: 'AV', name: 'Avellino', region: 'Campania' },
  { sigla: 'BN', name: 'Benevento', region: 'Campania' },
  { sigla: 'CE', name: 'Caserta', region: 'Campania' },
  { sigla: 'NA', name: 'Napoli', region: 'Campania' },
  { sigla: 'SA', name: 'Salerno', region: 'Campania' },
  // Emilia-Romagna
  { sigla: 'BO', name: 'Bologna', region: 'Emilia-Romagna' },
  { sigla: 'FC', name: 'Forlì-Cesena', region: 'Emilia-Romagna' },
  { sigla: 'FE', name: 'Ferrara', region: 'Emilia-Romagna' },
  { sigla: 'MO', name: 'Modena', region: 'Emilia-Romagna' },
  { sigla: 'PC', name: 'Piacenza', region: 'Emilia-Romagna' },
  { sigla: 'PR', name: 'Parma', region: 'Emilia-Romagna' },
  { sigla: 'RA', name: 'Ravenna', region: 'Emilia-Romagna' },
  { sigla: 'RE', name: 'Reggio Emilia', region: 'Emilia-Romagna' },
  { sigla: 'RN', name: 'Rimini', region: 'Emilia-Romagna' },
  // Friuli-Venezia Giulia
  { sigla: 'GO', name: 'Gorizia', region: 'Friuli-Venezia Giulia' },
  { sigla: 'PN', name: 'Pordenone', region: 'Friuli-Venezia Giulia' },
  { sigla: 'TS', name: 'Trieste', region: 'Friuli-Venezia Giulia' },
  { sigla: 'UD', name: 'Udine', region: 'Friuli-Venezia Giulia' },
  // Lazio
  { sigla: 'FR', name: 'Frosinone', region: 'Lazio' },
  { sigla: 'LT', name: 'Latina', region: 'Lazio' },
  { sigla: 'RI', name: 'Rieti', region: 'Lazio' },
  { sigla: 'RM', name: 'Roma', region: 'Lazio' },
  { sigla: 'VT', name: 'Viterbo', region: 'Lazio' },
  // Liguria
  { sigla: 'GE', name: 'Genova', region: 'Liguria' },
  { sigla: 'IM', name: 'Imperia', region: 'Liguria' },
  { sigla: 'SP', name: 'La Spezia', region: 'Liguria' },
  { sigla: 'SV', name: 'Savona', region: 'Liguria' },
  // Lombardia
  { sigla: 'BG', name: 'Bergamo', region: 'Lombardia' },
  { sigla: 'BS', name: 'Brescia', region: 'Lombardia' },
  { sigla: 'CO', name: 'Como', region: 'Lombardia' },
  { sigla: 'CR', name: 'Cremona', region: 'Lombardia' },
  { sigla: 'LC', name: 'Lecco', region: 'Lombardia' },
  { sigla: 'LO', name: 'Lodi', region: 'Lombardia' },
  { sigla: 'MB', name: 'Monza e della Brianza', region: 'Lombardia' },
  { sigla: 'MI', name: 'Milano', region: 'Lombardia' },
  { sigla: 'MN', name: 'Mantova', region: 'Lombardia' },
  { sigla: 'PV', name: 'Pavia', region: 'Lombardia' },
  { sigla: 'SO', name: 'Sondrio', region: 'Lombardia' },
  { sigla: 'VA', name: 'Varese', region: 'Lombardia' },
  // Marche
  { sigla: 'AN', name: 'Ancona', region: 'Marche' },
  { sigla: 'AP', name: 'Ascoli Piceno', region: 'Marche' },
  { sigla: 'FM', name: 'Fermo', region: 'Marche' },
  { sigla: 'MC', name: 'Macerata', region: 'Marche' },
  { sigla: 'PU', name: 'Pesaro e Urbino', region: 'Marche' },
  // Molise
  { sigla: 'CB', name: 'Campobasso', region: 'Molise' },
  { sigla: 'IS', name: 'Isernia', region: 'Molise' },
  // Piemonte
  { sigla: 'AL', name: 'Alessandria', region: 'Piemonte' },
  { sigla: 'AT', name: 'Asti', region: 'Piemonte' },
  { sigla: 'BI', name: 'Biella', region: 'Piemonte' },
  { sigla: 'CN', name: 'Cuneo', region: 'Piemonte' },
  { sigla: 'NO', name: 'Novara', region: 'Piemonte' },
  { sigla: 'TO', name: 'Torino', region: 'Piemonte' },
  { sigla: 'VB', name: 'Verbano-Cusio-Ossola', region: 'Piemonte' },
  { sigla: 'VC', name: 'Vercelli', region: 'Piemonte' },
  // Puglia
  { sigla: 'BA', name: 'Bari', region: 'Puglia' },
  { sigla: 'BR', name: 'Brindisi', region: 'Puglia' },
  { sigla: 'BT', name: 'Barletta-Andria-Trani', region: 'Puglia' },
  { sigla: 'FG', name: 'Foggia', region: 'Puglia' },
  { sigla: 'LE', name: 'Lecce', region: 'Puglia' },
  { sigla: 'TA', name: 'Taranto', region: 'Puglia' },
  // Sardegna (post-2025 reform)
  { sigla: 'CA', name: 'Cagliari', region: 'Sardegna' },
  { sigla: 'SS', name: 'Sassari', region: 'Sardegna' },
  { sigla: 'NU', name: 'Nuoro', region: 'Sardegna' },
  { sigla: 'OR', name: 'Oristano', region: 'Sardegna' },
  { sigla: 'SU', name: 'Sulcis Iglesiente', region: 'Sardegna' },
  { sigla: 'VS', name: 'Medio Campidano', region: 'Sardegna' },
  { sigla: 'OG', name: 'Ogliastra', region: 'Sardegna' },
  { sigla: 'OT', name: 'Gallura Nord-Est Sardegna', region: 'Sardegna' },
  // Sicilia
  { sigla: 'AG', name: 'Agrigento', region: 'Sicilia' },
  { sigla: 'CL', name: 'Caltanissetta', region: 'Sicilia' },
  { sigla: 'CT', name: 'Catania', region: 'Sicilia' },
  { sigla: 'EN', name: 'Enna', region: 'Sicilia' },
  { sigla: 'ME', name: 'Messina', region: 'Sicilia' },
  { sigla: 'PA', name: 'Palermo', region: 'Sicilia' },
  { sigla: 'RG', name: 'Ragusa', region: 'Sicilia' },
  { sigla: 'SR', name: 'Siracusa', region: 'Sicilia' },
  { sigla: 'TP', name: 'Trapani', region: 'Sicilia' },
  // Toscana
  { sigla: 'AR', name: 'Arezzo', region: 'Toscana' },
  { sigla: 'FI', name: 'Firenze', region: 'Toscana' },
  { sigla: 'GR', name: 'Grosseto', region: 'Toscana' },
  { sigla: 'LI', name: 'Livorno', region: 'Toscana' },
  { sigla: 'LU', name: 'Lucca', region: 'Toscana' },
  { sigla: 'MS', name: 'Massa-Carrara', region: 'Toscana' },
  { sigla: 'PI', name: 'Pisa', region: 'Toscana' },
  { sigla: 'PO', name: 'Prato', region: 'Toscana' },
  { sigla: 'PT', name: 'Pistoia', region: 'Toscana' },
  { sigla: 'SI', name: 'Siena', region: 'Toscana' },
  // Trentino-Alto Adige
  { sigla: 'BZ', name: 'Bolzano', region: 'Trentino-Alto Adige' },
  { sigla: 'TN', name: 'Trento', region: 'Trentino-Alto Adige' },
  // Umbria
  { sigla: 'PG', name: 'Perugia', region: 'Umbria' },
  { sigla: 'TR', name: 'Terni', region: 'Umbria' },
  // Valle d'Aosta
  { sigla: 'AO', name: 'Aosta', region: "Valle d'Aosta" },
  // Veneto
  { sigla: 'BL', name: 'Belluno', region: 'Veneto' },
  { sigla: 'PD', name: 'Padova', region: 'Veneto' },
  { sigla: 'RO', name: 'Rovigo', region: 'Veneto' },
  { sigla: 'TV', name: 'Treviso', region: 'Veneto' },
  { sigla: 'VE', name: 'Venezia', region: 'Veneto' },
  { sigla: 'VI', name: 'Vicenza', region: 'Veneto' },
  { sigla: 'VR', name: 'Verona', region: 'Veneto' },
]

/** Dropdown options, alphabetical by province name: "Milano (MI)" → value "MI". */
export const ITALIAN_PROVINCE_OPTIONS = [...ITALIAN_PROVINCES]
  .sort((a, b) => a.name.localeCompare(b.name, 'it'))
  .map((p) => ({ value: p.sigla, label: `${p.name} (${p.sigla})` }))

/** Region for a province sigla — the value stored in addressData.state. */
export function regionForProvince(sigla: string): string {
  return ITALIAN_PROVINCES.find((p) => p.sigla === sigla)?.region || ''
}
